import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  background-color: #002f6c; /* Dark blue */
  padding: 20px 24px;
  border-radius: 32px;
  // max-width: 1000px;
  position: relative;
  color: white;
`;

const LabelSkeleton = styled.div`
  position: absolute;
  top: -14px;
  left: 16px;
  background: white;
  border-radius: 16px;
  padding: 4px 12px;
  width: 140px;
  height: 24px;
  box-shadow: 0px 1px 0px gray, 0px -1px 0px 0px gray;
`;

const SelectButtonSkeleton = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
  background: #ff7832;
  color: white;
  border-radius: 28px;
  width: 90px;
  height: 36px;
  box-shadow: 0px 1px 0px gray, 0px -1px 0px 0px gray;
`;

const SkeletonWrittenResponse = () => {
  return (
    <Container>
      <LabelSkeleton />
      <SelectButtonSkeleton />
      <Skeleton
        active
        title={false}
        paragraph={{
          rows: 1,
          width: '80%',
        }}
        style={{ backgroundColor: 'transparent' }}
      />
      <Skeleton
        active
        title={false}
        paragraph={{
          rows: 4,
          width: ['100%', '98%', '92%', '60%'],
        }}
        style={{ backgroundColor: 'transparent', marginTop: 16 }}
      />
    </Container>
  );
};

export default SkeletonWrittenResponse;